/*
 * File: /src/stores/shopifyApi.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 4:27:57 pm
 * Last Modified: Friday, 21st September 2018 1:30:35 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import axios from 'axios'
import objectPath from 'object-path'
import NProgress from 'nprogress'
import { FileDownloadHelper, getSessionToken } from '@/helpers'
import { parse, stringify } from 'flatted/esm';

const apiBaseUrl = `${process.env.API_HOST}/${process.env.API_BASE}/shopify/`

const initialState = () => ({
    apiBaseUrl,
    openedHTTPs: 0
})

const state = () => (initialState())

const actions = {
    async REQUEST({commit}, {endpoint, shopifyEndpoint, data, params, method, headers}) {
        const send = async () => {
            const token = await getSessionToken()
            const _headers = {
                Authorization: `Bearer ${token}`,
                ...(shopifyEndpoint ? { 'X-Shopify-Endpoint': shopifyEndpoint } : {}),
                ...headers
            }

            return axios({
                method: method || 'GET',
                // Get rid of circular structure
                data: parse(stringify(data)),
                url: `${apiBaseUrl}${endpoint}`,
                headers: _headers,
                params
            })
        }

        const shouldRetry = error => !!(
            error.response &&
            error.response.status === 401 &&
            error.response.headers &&
            error.response.headers['x-shopify-retry-invalid-session-request'] === '1'
        )

        commit('SET_OPENED_HTTPS', true)
        try {
            let response
            try {
                response = await send()
            } catch (error) {
                if (!shouldRetry(error)) {
                    throw error
                }
                // Invalid or expired ID token: retry once with a fresh one
                response = await send()
            }
            return response.data
        } finally {
            commit('SET_OPENED_HTTPS', false)
        }
    },

    async SCHEMA_EXPORT({state, dispatch}) {
        try {
            let data = await dispatch('REQUEST', {
              endpoint: 'metafields/export'
            })
            FileDownloadHelper({ 
                data,
                filename: 'airfields_schema_export.json'
            })
          } catch (error) {
            throw error
          }
    },

    async SCHEMA_IMPORT({state, dispatch}, { content }) {
        // let content = await FileUploadHelper()
        let metafields = JSON.parse(content)

        try {
            await dispatch('REQUEST', {
                method: 'POST',
                endpoint: 'metafields/import',
                data: metafields
            })
            // console.log('Schema imported')
        } catch (error) {
            throw error
        }
    }
}

const mutations = {
    SET_OPENED_HTTPS (state, increament) {
        if (increament) {
            state.openedHTTPs++
        } else {
            state.openedHTTPs--
        }

        if (state.openedHTTPs) {
            NProgress.start()
            NProgress.set(0.2)
        } else {
            NProgress.done()
        }
    }
}

const getters = {
    openedHTTPs: state => state.openedHTTPs
}

export default {
  namespaced: true,
  state, actions, mutations, getters
}


// WEBPACK FOOTER //
// ./src/stores/shopify-api.js